function createProductCard() {
  var productCards = document.querySelectorAll('.product-item');
  var productGrid = document.getElementById('ProductGridContainer');
  var highestPrice = 0; // Variable to store the highest price

  productCards.forEach(productCard => {
    var price = processProductCard(productCard);
    if (price > highestPrice) {
      highestPrice = price;
    }
  });

  // Log or use the highest price as needed
  console.log('Highest Price: $' + (highestPrice / 100).toFixed(2));

  if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {
    var priceInput = document.getElementById('Filter-Price-LTE');
    var maxPriceTitle = document.querySelector('.max-price-title');

    if (maxPriceTitle) {
      maxPriceTitle.textContent = 'The highest price is ' + (highestPrice / 100).toFixed(2)
    }
    if (priceInput) {
      priceInput.setAttribute('placeholder', (highestPrice / 100).toFixed(2));
      priceInput.setAttribute('max', (highestPrice / 100).toFixed(2));
    }
  }
}

function processProductCard(productCard) {
  if (productCard.hasAttribute('data-gift-card-product')) {
    return;
  }

  if (productCard.hasAttribute('data-frozen') && productCard.getAttribute('data-frozen') === 'true') {
    productCard.remove();
    return;
  }

  var priceWrapper = productCard.querySelector(".dynamic-price__wrapper"),
    submitButton = productCard.querySelector(".submit-button"),
    productIDInput = productCard.querySelector('input[name="id"]'),
    itemQuantityWrapper = productCard.querySelector(".quick-add__quantity"),
    itemQuantity = productCard.querySelector(".collection-quantity-selector"),
    variants = productCard.getAttribute("data-all-variants"),
    additionalWrapper = productCard.querySelector(".additional"),
    specialBadge = productCard.querySelector(".special-badge"),
    productForm = productCard.querySelector("product-form"),
    productOfOrigin,
    productCardVariants = addslashes(variants),
    partsOfStr = variants.split(";"),
    pickingStore = !$.cookie("picking_store")
      ? 73
      : $.cookie("picking_store"),
    pickingStoreVariant = "s:" + pickingStore;
 
  var maxPrice = 0;

  for (var i = 0; i < partsOfStr.length; i++) {
    var variantArray = partsOfStr[i].split(",");
    if (variantArray[0].trim() == pickingStoreVariant.trim()) {
      var special = variantArray[2],
        additional = variantArray[3],
        price = parseInt(variantArray[5]),
        compareAtPrice = parseInt(variantArray[6]),
        conversionFactor = productCard.getAttribute('data-conversion-factor'),
        uom = productCard.getAttribute('data-uom'),
        hideInState = productForm.dataset.hideinstate,
        overrideCupValue = productCard.getAttribute('data-overridecupvalue'),
        giftCardProduct = productForm.dataset.giftcard,
        variantIdToCheck = parseInt(variantArray[4]),
        productOfOrigin = variantArray[1];

      productIDInput.value = variantArray[4];
      productCard.setAttribute("data-variant-id", variantArray[4]);
      if (itemQuantityWrapper) {
        itemQuantityWrapper.setAttribute("data-id", variantArray[4]);
        itemQuantity.value = 0;
        
        // Check for data-max-quantity attribute first, otherwise use variant quantity
        if (productCard.hasAttribute('data-max-quantity')) {
          const maxQuantity = productCard.getAttribute('data-max-quantity');
          itemQuantity.setAttribute("max", maxQuantity);
        } else {
          const variantQuantityAvailable = variantArray[7];
          itemQuantity.setAttribute("max", variantQuantityAvailable);
        }
      }

      if (additional) {
        additionalWrapper.innerHTML = additional;
        additionalWrapper.classList.add("show-additional");
      }

      const pod = productCard.querySelector('.product-of-origin');
      if (pod) {
        if (productOfOrigin) {
          pod.innerHTML = productOfOrigin;
        } else {
          pod.style.display = 'none';
        }
      }

      priceWrapper.querySelector(".sale .from_price").innerHTML = "$" + (price / 100).toFixed(2);

      if (special && special !== "Default") {
        priceWrapper.querySelector(".unit_price").classList.add("is-special");
        specialBadge.classList.add("show-additional");
      }
      if (!compareAtPrice || overrideCupValue == "Yes") {
        if (uom != "") {
          priceWrapper.querySelector(".sale .compare_at_price").innerHTML = "<small>$" + ((price * conversionFactor) / 100).toFixed(2) + " " + uom + "</small>";
        }
      } else {
        if (uom != "") {
          priceWrapper.querySelector(".sale .compare_at_price").innerHTML = "<small>$" + (compareAtPrice / 100).toFixed(2) + " " + uom + "</small>";
        } else {
          priceWrapper.querySelector(".sale .compare_at_price").innerHTML = "<small>$" + (compareAtPrice / 100).toFixed(2) + " per kg</small>";
        }
      }

      priceWrapper.classList.remove('price-visually-hidden');

      if (parseInt(variantArray[7]) <= 0 || hideInState.indexOf(currState) != -1) {
        productCard.remove();
        if (submitButton) {
          submitButton.remove();
          productIDInput.disabled = true;
        }
      } else {
        if (submitButton) {
          let productCardSpan = submitButton.querySelector('.touch-submit');
          if (productCardSpan) {
            productCardSpan.innerHTML = `Add to cart <svg class="icon icon-cart" role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>`
          }
          productCard.classList.add("card-in-stock");
          submitButton.disabled = false;
          productIDInput.disabled = false;
        }
      }

      // Update maxPrice if this variant price is higher
      if (price > maxPrice) {
        maxPrice = price;
      }
    }
  }

  return maxPrice;
}

// Attach functions to window object to make them globally accessible
window.createProductCard = createProductCard;
window.processProductCard = processProductCard;

document.addEventListener("DOMContentLoaded", function () {
  createProductCard();
}); 